import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import Dropdown from 'react-bootstrap/Dropdown';
import { useRootStore } from '../../../loaders/useRootStore';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Form } from 'react-bootstrap';

interface PropsType {
    [key: string]: any,

    gameEnvironments?: IGameEnvironment[]
    selectedGameEnvironments: IGameEnvironment[],
    handleGameEnvironmentSelected?: (gameEnvironment: IGameEnvironment) => void,
    handleGameEnvironmentUnselected?: (gameEnvironment: IGameEnvironment) => void,
}

export const GameEnvironmentMultiSelector: FC<PropsType> = observer(({
                                                                         gameEnvironments,
                                                                         selectedGameEnvironments,
                                                                         handleGameEnvironmentSelected,
                                                                         handleGameEnvironmentUnselected,
                                                                         ...props
                                                                     }) => {
    const rootStore = useRootStore();

    const handleToggleGameEnvironment = (gameEnvironment: IGameEnvironment) => {
        selectedGameEnvironments.find(gv => gv === gameEnvironment)
            ? handleGameEnvironmentUnselected && handleGameEnvironmentUnselected(gameEnvironment)
            : handleGameEnvironmentSelected && handleGameEnvironmentSelected(gameEnvironment);
    };

    return (
        <DropdownButton align="end" autoClose={false} {...props} data-testid={'ddlGameEnvironmentMultiSelector'}
                        variant="outline-primary" title={`Select Environment(s): ${selectedGameEnvironments.length}`}>

            <React.Fragment>
                {(gameEnvironments ?? rootStore.gameEnvironmentsStore.gameEnvironments)
                    .map(gameEnvironment => {
                        return <Dropdown.Item key={gameEnvironment.id}
                                              as="button">
                            <Form.Check
                                type={'checkbox'}
                                id={gameEnvironment.id.toString()}
                                label={gameEnvironment.name}
                                onClick={() => handleToggleGameEnvironment(gameEnvironment)}
                                data-testid={`gameEnvironmentMultiSelectorButton${gameEnvironment.name}`}
                            />
                        </Dropdown.Item>;
                    })}
            </React.Fragment>
        </DropdownButton>
    );
});

